import { DescriptionBanner } from '../components/DescriptionBanner';
import { useStoreDealGuideBannerService } from '../services/useStoreDealGuideBannerService';

export const StoreDealGuideBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useStoreDealGuideBannerService();

  if (service.is_hide) {
    return null;
  }

  return <DescriptionBanner guidance_image_url={service.guidance_image_url} />;
};
